import { useState } from 'react';
import { SelectBox } from '@/components/SelectBox';

const platformEcommerceOptions = [
    { value: '1', text: 'VTEX' },
    { value: '2', text: 'MAGENTO' },
    { value: '3', text: 'TIENDA NUBE' },
    { value: '4', text: 'SHOPIFY' },
    { value: '5', text: 'EMPRETIENDA' },
    { value: '6', text: 'WOOCOMMERCE' },
    { value: '7', text: 'INTEGRACIÓN PROPIA' },
    { value: '8', text: 'SHOPIFY-COMBINATORIA' },
    { value: '10', text: 'AVENIDA+' },
    { value: '12', text: 'PROVINCIA COMPRAS' },
];

const SelectPlataformaEcommerce = ({ check, onChange }) => {
    const [selectedPlatform, setSelectedPlatform] = useState(null);

    const handlePlatformChange = (e) => {
        setSelectedPlatform(e.value);
        onChange({
            target: {
                name: 'platform_ecommerce_id',
                value: e.value,
                text: e.value,
                platform_ecommerce: e.label,
            },
        });
    };

    return (
        <div className='mb-24'>
            <SelectBox
                title='Plataforma E-commerce'
                name='platform_ecommerce_id'
                value={selectedPlatform}
                validation={check}
                options={platformEcommerceOptions}
                onChange={handlePlatformChange}
            />
        </div>
    );
};

export default SelectPlataformaEcommerce;
